import React, { useContext, useMemo } from "react";
import { Event } from "../../../types";
import moment from "moment";
import { TimerWithSuffix } from "../../Timer/TimerWithSuffix";
import Button from "../../Button";
import { StoreContext } from "../../../Context/StoreContext";
import { Link } from "react-router-dom";
import { convertToDecimal } from "../../../utils/utils";

const EventHappeningCard = (event: Event) => {
  const { state } = useContext(StoreContext);

  const {
    auth: { user },
  } = state;
  const eventStartTime = moment(event.startDate);
  const currentTime = moment();

  const zone = moment.tz.guess();
  const abbr = moment.tz(zone).format("z");

  const isInvitedUser = useMemo(() => {
    return event?.rsvps?.some(
      (rsvp) => rsvp.user._id === user?._id && rsvp.status === "invited",
    );
  }, [event?.rsvps]);

  return (
    <div className="flex bg-frescoWhite justify-between items-center gap-2.5 px-2 py-3 rounded-2xl">
      <div className="flex items-center gap-2">
        <Link to={`/rooms/${event.room}/events/${event._id}`}>
          <div
            title={event.title}
            className=" h-51px w-51px flex justify-center items-end rounded-xl cursor-pointer p-2  relative bg-no-repeat bg-cover bg-blend-multiply"
            style={{
              backgroundImage: `url(
                ${event.cover ? event.cover?.urls?.small : ""}
                )`,
            }}
          >
            {event.isPaidEvent && (
              <div className="py-1 w-full rounded bg-primaryGreen text-frescoWhite text-xs font-bold text-center z-10">
                ${convertToDecimal(event.price)}
              </div>
            )}
          </div>
        </Link>
        <p className=" text-darkNight text-sm">
          {isInvitedUser ? (
            <>
              You were invited to{" "}
              <span className="font-medium">{event.title}</span> is at{" "}
              {eventStartTime?.format(`h:mm a [${abbr}]`)}{" "}
            </>
          ) : (
            <>
              <span className="font-medium">{event.title}</span> is at{" "}
              {eventStartTime?.format(`h:mm a [${abbr}]`)}
              <br />
            </>
          )}
          <span className="text-darkGray text-xs flex gap-1">
            {eventStartTime > currentTime ? (
              <>
                ⏰ starting in{" "}
                <span className="font-medium inline-block text-darkNight ">
                  <TimerWithSuffix date={eventStartTime} />
                </span>
              </>
            ) : (
              <>
                ⏰ started{" "}
                <span className="font-medium text-darkNight ">
                  {eventStartTime?.fromNow()}
                </span>
              </>
            )}
          </span>
        </p>
      </div>
      <Link
        className="whitespace-nowrap"
        to={`/rooms/${event.room}/events/${event._id}`}
      >
        <Button onClick={() => {}} variant="vibhut-primary" size="vibhut-sm">
          Join Now
        </Button>
      </Link>
    </div>
  );
};

export default EventHappeningCard;
